// src/pages/RequirementsPage.js
import React, { useState, useEffect } from 'react';
import axios from 'axios'; // 假设需要提交数据到后端
import { useLocation } from 'react-router-dom'; // Import useLocation
import { Container, 
    Box, 
    Typography, 
    Radio,
    CssBaseline, 
    RadioGroup, 
    FormControlLabel,FormGroup,Checkbox,MenuItem,Select,Form,
    FormControl, FormLabel, TextField, Button, List, ListItem, IconButton, ListItemSecondaryAction } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const RequirementsPage = () => {
    const [inputMode, setInputMode] = useState('KeyValuePoints'); // 默认模式为只录入关键价值点
    const [keyValuePoints, setKeyValuePoints] = useState('');
    const [content, setContent] = useState('');
    const [metrics, setMetrics] = useState([{ name: '', targetValue: '', unit: '', description: '' }]); // 指标列表

    const [productPositioning, setProductPositioning] = useState('');
    const [coverage, setCoverage] = useState([]);
    const [competitiveness, setCompetitiveness] = useState('');
    const [outputArtifacts, setOutputArtifacts] = useState([]);
    const [optimizationGoals, setOptimizationGoals] = useState([]);

    const [optimizationDirection, setOptimizationDirection] = useState([]);
    const [intelligentUpgradeDirection, setIntelligentUpgradeDirection] = useState([]);

    const [dataSource, setDataSource] = useState([]);
    const [pdfFiles, setPdfFiles] = useState([]); // 用于文件上传
    const [drawingFiles, setDrawingFiles] = useState([]);
    const [dataFiles, setDataFiles] = useState([]);
    const [extractionMethod, setExtractionMethod] = useState('auto');
    const [extractionDescription, setExtractionDescription] = useState('');

    const [buildingGoal, setBuildingGoal] = useState('');
    const [businessUncertaintyData, setBusinessUncertaintyData] = useState(''); // 示例，根据实际需求添加
    const [intelligentAlgorithmDirection, setIntelligentAlgorithmDirection] = useState('');
    const [modelTrainingDataSource, setModelTrainingDataSource] = useState('');
    const [expectedIntelligentCapabilities, setExpectedIntelligentCapabilities] = useState('');

    const [activeTab, setActiveTab] = useState('basic'); // 用于控制 Tab 切换

    const location = useLocation(); // Use useLocation to get location object

    useEffect(() => {
        document.title = '需求 - 责联网'; // 设置当前页面的标题
        // Access state passed from HomePage
        const searchKeywords = location.state?.searchKeywords;
        if (searchKeywords) {
            setKeyValuePoints(searchKeywords); // Pre-fill keyValuePoints with search keywords
            // Or, if you want to pre-fill content instead, use:
            // setContent(searchKeywords);
        }
    }, [location.state],[location.pathname]); // Depend on location.state to re-run effect when state changes

    const handleInputModeChange = (event) => {
        setInputMode(event.target.value);
    };

    const handleKeyValuePointsChange = (event) => {
        setKeyValuePoints(event.target.value);
    };

    const handleContentChange = (event) => {
        setContent(event.target.value);
    };

    const handleMetricChange = (index, field, value) => {
        const newMetrics = [...metrics];
        newMetrics[index][field] = value;
        setMetrics(newMetrics);
    };

    const handleAddMetric = () => {
        setMetrics([...metrics, { name: '', targetValue: '', unit: '', description: '' }]);
    };

    const handleRemoveMetric = (index) => {
        const newMetrics = metrics.filter((_, i) => i !== index);
        setMetrics(newMetrics);
    };

    const handleProductPositioningChange = (event) => {
        setProductPositioning(event.target.value);
    };
    
    const handleCoverageChange = (event) => {
        const { value, checked } = event.target;
        setCoverage(checked ? [...coverage, value] : coverage.filter(item => item !== value));
    };
    
    const handleCompetitivenessChange = (event) => {
        setCompetitiveness(event.target.value);
    };
    
    const handleOutputArtifactsChange = (event) => {
        const { value, checked } = event.target;
        setOutputArtifacts(checked ? [...outputArtifacts, value] : outputArtifacts.filter(item => item !== value));
    };
    
    const handleOptimizationGoalsChange = (event) => {
        const { value, checked } = event.target;
        setOptimizationGoals(checked ? [...optimizationGoals, value] : optimizationGoals.filter(item => item !== value));
    };
    
    const handleOptimizationDirectionChange = (event) => {
        const { value, checked } = event.target;
        setOptimizationDirection(checked ? [...optimizationDirection, value] : optimizationDirection.filter(item => item !== value));
    };
    
    const handleIntelligentUpgradeDirectionChange = (event) => {
        const { value, checked } = event.target;
        setIntelligentUpgradeDirection(checked ? [...intelligentUpgradeDirection, value] : intelligentUpgradeDirection.filter(item => item !== value));
    };
    
    const handleDataSourceChange = (event) => {
        const { value, checked } = event.target;
        setDataSource(checked ? [...dataSource, value] : dataSource.filter(item => item !== value));
    };
    
    const handleExtractionMethodChange = (event) => {
        setExtractionMethod(event.target.value);
    };
    const handleExpectedIntelligentCapabilities = (event) => {
        // setExpectedIntelligentCapabilities(event.target.value);
        setExpectedIntelligentCapabilities(event.target.value);
    };
    const handleIntelligentAlgorithmDirectionChange = (event) => {
        setIntelligentAlgorithmDirection(event.target.value);
    };
    const handleExtractionDescriptionChange = (event) => {
        setExtractionDescription(event.target.value);
    };
    
    const handleBuildingGoalChange = (event) => {
        setBuildingGoal(event.target.value);
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        let requirementData = { inputMode };

        if (inputMode === 'KeyValuePoints') {
            requirementData.keyValuePoints = keyValuePoints.split(',').map(item => item.trim()).filter(item => item); // 假设逗号分隔
        } else if (inputMode === 'ContentAndMetrics' || inputMode === 'Combined') {
            requirementData.content = content;
            requirementData.metrics = metrics.filter(metric => metric.name || metric.targetValue); // 仅包含有名称或目标值的指标
            if (inputMode === 'Combined') {
                requirementData.keyValuePoints = keyValuePoints.split(',').map(item => item.trim()).filter(item => item);
            }
        }

        // 添加新的需求分类数据
        requirementData.productPositioning = productPositioning;
        requirementData.coverage = coverage;
        requirementData.competitiveness = competitiveness;
        requirementData.outputArtifacts = outputArtifacts;
        requirementData.optimizationGoals = optimizationGoals;
        requirementData.optimizationDirection = optimizationDirection;
        requirementData.intelligentUpgradeDirection = intelligentUpgradeDirection;

        // 添加数据与机理信息
        requirementData.dataSource = dataSource;
        requirementData.extractionMethod = extractionMethod;
        requirementData.extractionDescription = extractionDescription;
        requirementData.buildingGoal = buildingGoal;
        // requirementData.businessUncertaintyData = businessUncertaintyData; // 添加其他数据机理 state
        requirementData.intelligentAlgorithmDirection = intelligentAlgorithmDirection;
        requirementData.modelTrainingDataSource = modelTrainingDataSource;
        requirementData.expectedIntelligentCapabilities = expectedIntelligentCapabilities;

        console.log('提交的需求数据:', requirementData);
        // 在这里可以调用 axios 发送到后端 API
        // axios.post('/api/requirements', requirementData, {
        //     headers: {
        //         'Authorization': `Bearer ${localStorage.getItem('token')}` // 如果需要token
        //     }
        // })
        // .then(response => {
        //     alert('需求创建成功！');
        //     // 清空表单或跳转
        // })
        // .catch(error => {
        //     console.error('创建需求失败:', error);
        //     alert('创建需求失败: ' + (error.response?.data?.message || '请稍后重试'));
        // });
    };

    return (
        <Container component="main" maxWidth="md" sx={{ mt: 4 }}>
        <CssBaseline />
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography component="h1" variant="h5" sx={{ mb: 2 }}>
                创建需求
            </Typography>
            <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                （目前本网站所有的解决方案都源自于各种需求，通过需求智能生成。）
            </Typography>

            {/* Tab 导航 */}
            <Box sx={{ mb: 2 }}>
                <Button onClick={() => handleTabChange('basic')} variant={activeTab === 'basic' ? 'contained' : 'outlined'} sx={{ mr: 1 }}>基本需求</Button>
                <Button onClick={() => handleTabChange('extended')} variant={activeTab === 'extended' ? 'contained' : 'outlined'} sx={{ mr: 1 }}>详细分类</Button>
                <Button onClick={() => handleTabChange('data')} variant={activeTab === 'data' ? 'contained' : 'outlined'} sx={{ mr: 1 }}>数据与机理</Button>
                {/* <Button onClick={() => handleTabChange('dialog')} variant={activeTab === 'dialog' ? 'contained' : 'outlined'}>对话需求</Button> */}
            </Box>

            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3, width: '100%', maxWidth: 800 }}>
                {activeTab === 'basic' && (
                    <>
                        <FormControl component="fieldset" sx={{ mb: 2, width: '100%', maxWidth: 500 }}>
                            <FormLabel component="legend">选择需求录入模式</FormLabel>
                            <RadioGroup row aria-label="input-mode" name="inputMode" value={inputMode} onChange={handleInputModeChange}>
                                <FormControlLabel value="KeyValuePoints" control={<Radio />} label="关键价值点" />
                                <FormControlLabel value="ContentAndMetrics" control={<Radio />} label="内容和指标" />
                                <FormControlLabel value="Combined" control={<Radio />} label="组合模式" />
                            </RadioGroup>
                        </FormControl>

                        {(inputMode === 'KeyValuePoints' || inputMode === 'Combined') && (
                            <TextField margin="normal" fullWidth multiline rows={4} id="keyValuePoints" label="关键价值点 (多个请用逗号或换行分隔)" name="keyValuePoints" placeholder="..." value={keyValuePoints} onChange={handleKeyValuePointsChange} />
                        )}

                        {(inputMode === 'ContentAndMetrics' || inputMode === 'Combined') && (
                            <TextField margin="normal" fullWidth multiline rows={3} id="content" label="需求内容描述" name="content" placeholder="..." value={content} onChange={handleContentChange} />
                        )}

                        {(inputMode === 'ContentAndMetrics' || inputMode === 'Combined') && (
                            <Box sx={{ mt: 2 }}>
                                <Typography variant="subtitle1">需求指标</Typography>
                                <List sx={{ width: '100%' }}>
                                    {metrics.map((metric, index) => (
                                        <ListItem key={index}>
                                            {/* 指标输入框 */}
                                        </ListItem>
                                    ))}
                                </List>
                                <Button startIcon={<AddIcon />} onClick={handleAddMetric}>添加指标</Button>
                            </Box>
                        )}
                    </>
                )}

                {activeTab === 'extended' && (
                    <Box>
                        <Typography variant="h6" sx={{ mb: 1 }}>产品相关分类</Typography>
                        <FormControl fullWidth margin="normal">
                            <FormLabel id="product-positioning-label">产品定位</FormLabel>
                            <RadioGroup aria-labelledby="product-positioning-label" name="productPositioning" value={productPositioning} onChange={handleProductPositioningChange} row>
                                <FormControlLabel value="new" control={<Radio />} label="新产品" />
                                <FormControlLabel value="upgrade" control={<Radio />} label="升级" />
                                <FormControlLabel value="extension" control={<Radio />} label="扩展" />
                            </RadioGroup>
                        </FormControl>

                        <FormControl component="fieldset" fullWidth margin="normal">
                            <FormLabel component="legend">覆盖面</FormLabel>
                            <FormGroup row>
                                <FormControlLabel control={<Checkbox value="allBusinessProcesses" checked={coverage.includes('allBusinessProcesses')} onChange={handleCoverageChange} />} label="全业务过程" />
                                <FormControlLabel control={<Checkbox value="businessScenarios" checked={coverage.includes('businessScenarios')} onChange={handleCoverageChange} />} label="业务场景" />
                                <FormControlLabel control={<Checkbox value="applicationScenarios" checked={coverage.includes('applicationScenarios')} onChange={handleCoverageChange} />} label="应用场景" />
                                <FormControlLabel control={<Checkbox value="operationScenarios" checked={coverage.includes('operationScenarios')} onChange={handleCoverageChange} />} label="操作场景" />
                            </FormGroup>
                        </FormControl>

                        {/* ... (其他详细分类的 UI 元素，例如竞争力、输出成果、优化目标等，使用 RadioGroup, Checkbox, Select 等) */}

                        <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>针对已有系统的细化分类</Typography>
                        {/* ... (新能源汽车齿轮相关的分类 UI 元素) */}
                    </Box>
                )}

                {activeTab === 'data' && (
                    <Box>
                        <Typography variant="h6" sx={{ mb: 1 }}>数据与机理的提取</Typography>
                        <FormControl component="fieldset" fullWidth margin="normal">
                            <FormLabel component="legend">选择数据来源</FormLabel>
                            <FormGroup row>
                                <FormControlLabel control={<Checkbox value="existingSoftware" checked={dataSource.includes('existingSoftware')} onChange={handleDataSourceChange} />} label="已有软件系统" />
                                <FormControlLabel control={<Checkbox value="pdfDocuments" checked={dataSource.includes('pdfDocuments')} onChange={handleDataSourceChange} />} label="PDF文档" />
                                {/* ... (其他数据来源复选框) */}
                            </FormGroup>
                        </FormControl>

                        {dataSource.includes('pdfDocuments') && (
                            <Box sx={{ mt: 2 }}>
                                {/* 文件上传组件 */}
                            </Box>
                        )}

                        <FormControl component="fieldset" fullWidth margin="normal">
                            <FormLabel component="legend">提取方式</FormLabel>
                            <RadioGroup aria-label="extraction-method" name="extractionMethod" value={extractionMethod} onChange={handleExtractionMethodChange} row>
                                <FormControlLabel value="auto" control={<Radio />} label="自动提取" />
                                <FormControlLabel value="manual" control={<Radio />} label="手动标注" />
                            </RadioGroup>
                        </FormControl>

                        <TextField fullWidth multiline rows={3} margin="normal" label="提取内容描述" value={extractionDescription} onChange={handleExtractionDescriptionChange} />

                        <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>数据、机理和智能机理的构建</Typography>
                        <FormControl fullWidth margin="normal">
                            <FormLabel id="building-goal-label">构建目标</FormLabel>
                            <Select labelId="building-goal-label" id="building-goal" value={buildingGoal} onChange={handleBuildingGoalChange}>
                                <MenuItem value="commercialUncertainty">产品的商业不确定性空间</MenuItem>
                                {/* ... (其他构建目标选项) */}
                            </Select>
                        </FormControl>

                        {buildingGoal === 'commercialUncertainty' && (
                            <TextField fullWidth multiline rows={3} margin="normal" label="商业模式相关数据" value={businessUncertaintyData} onChange={(e) => setBusinessUncertaintyData(e.target.value)} />
                        )}

                        {/* ... (其他构建目标对应的输入框) */}

                        <FormControl fullWidth margin="normal">
                            <FormLabel id="algorithm-direction-label">选择智能算法方向</FormLabel>
                            <RadioGroup aria-labelledby="algorithm-direction-label" name="intelligentAlgorithmDirection" value={intelligentAlgorithmDirection} onChange={handleIntelligentAlgorithmDirectionChange}>
                                <FormControlLabel value="riskAwareLearning" control={<Radio />} label="风险尽责学习" />
                                <FormControlLabel value="rootCauseDecision" control={<Radio />} label="根因智能 + 决策智能" />
                            </RadioGroup>
                        </FormControl>

                        <TextField fullWidth margin="normal" label="模型训练数据来源" value={modelTrainingDataSource} onChange={(e) => setModelTrainingDataSource(e.target.value)} />
                        <TextField fullWidth multiline rows={3} margin="normal" label="期望的智能能力" value={expectedIntelligentCapabilities} onChange={handleExpectedIntelligentCapabilities} />
                    </Box>
                )}

                {/* 对话需求 Tab (可以实现为一个单独的组件) */}
                {/* {activeTab === 'dialog' && <DialogRequirement />} */}

                <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
                    提交需求
                </Button>
            </Box>
        </Box>
    </Container>
);
}

export default RequirementsPage;